import { useDataValue } from 'Simple/Data.js'
import { useGetSignedUrl } from 'Data/s3'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let rurl = useDataValue({
    context: 'event_action',
    path: 'data.email_template.url',
    viewPath: props.viewPath,
  })

  let url = useGetSignedUrl({
    once: true,
    url: rurl,
    viewPath: props.viewPath,
  })

  return {
    variables: { url },
    pause: !url,
  }
}
